import React, { useContext } from "react";
import "./spinner.css";
import { AuthContext } from "../models/AuthContextProvider";

function Spinner() {
  const { isLoading } = useContext(AuthContext);

  if (isLoading === true) {
    return (
      <div className="spinner-wrapper">
        <div className="loader"></div>
      </div>
    );
  }

  return null;
}

export default Spinner;
